import styled from "../../styled-components.mjs";
export var Trigger = styled.span.withConfig({
  displayName: "Trigger",
  componentId: "sc-1q.mjssw-0"
})(["display:inline-flex;position:relative;"]);
export default Trigger;